function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1940(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 11.78,
    height: 2.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 1.195
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.39,
    width: 11.78,
    height: 12.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 8.72
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.05,
    width: 11.78,
    height: 20.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9633333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 25.09
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.13,
    width: 11.78,
    height: 28.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6828571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 49.39
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.65,
    width: 11.78,
    height: 29.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3088888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 78.295
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.94,
    width: 11.78,
    height: 38.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 112.045
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 131.15,
    width: 11.78,
    height: 42.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 152.335
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.51,
    width: 11.78,
    height: 46.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 196.6
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.69,
    width: 11.78,
    height: 51.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3088888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 245.665
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 271.64,
    width: 11.78,
    height: 52.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 298.04499999999996
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 324.45,
    width: 11.78,
    height: 53.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9633333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 351.015
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 377.58,
    width: 11.78,
    height: 56.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9633333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 405.97499999999997
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 434.38,
    width: 11.78,
    height: 60.31,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9633333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 464.53499999999997
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.68,
    width: 11.78,
    height: 62.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 525.74
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 556.81,
    width: 11.78,
    height: 71.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 592.5849999999999
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 628.36,
    width: 11.78,
    height: 71.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.89,
    y: 664.1800000000001
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 0,
    width: 23.28,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.586666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 23.42,
    y: 20.08
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.06,
    y: 0,
    width: 23.56,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9266666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.84,
    y: 20.08
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.62,
    y: 0,
    width: 24.74,
    height: 40.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.123333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.99,
    y: 20.08
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.36,
    y: 0,
    width: 26.94,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.735
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.83,
    y: 20.08
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.3,
    y: 0,
    width: 27.41,
    height: 40.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.568333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 124.005,
    y: 20.08
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.71,
    y: 0,
    width: 31.74,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.58,
    y: 20.08
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.45,
    y: 0,
    width: 32.69,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.448333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.795,
    y: 20.08
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.14,
    y: 0,
    width: 40.51,
    height: 40.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.39499999999998,
    y: 20.08
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.65,
    y: 0,
    width: 45.58,
    height: 40.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.44,
    y: 20.08
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.23,
    y: 0,
    width: 45.98,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.032
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.22,
    y: 20.08
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.21,
    y: 0,
    width: 46.41,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.41499999999996,
    y: 20.08
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.62,
    y: 0,
    width: 46.91,
    height: 40.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.462222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.075,
    y: 20.08
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.53,
    y: 0,
    width: 47.52,
    height: 40.16,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.28999999999996,
    y: 20.08
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.06,
    y: 0,
    width: 47.97,
    height: 40.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.045,
    y: 20.08
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.03,
    y: 0,
    width: 54.91,
    height: 40.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.485,
    y: 20.08
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.94,
    y: 0,
    width: 59.42,
    height: 40.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.677333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.6500000000001,
    y: 20.08
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.36,
    y: 0,
    width: 62.64,
    height: 40.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6933333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.6800000000001,
    y: 20.08
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 40.16,
    width: 58.19,
    height: 47.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.466
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 63.824999999999996
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 87.49,
    width: 58.19,
    height: 54.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.158333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 114.965
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 142.44,
    width: 58.19,
    height: 56.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 170.81
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 199.18,
    width: 58.19,
    height: 57.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.793
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 228.145
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 257.11,
    width: 58.19,
    height: 58.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 286.27500000000003
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 315.44,
    width: 58.19,
    height: 68.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.312857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 349.75
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 384.06,
    width: 58.19,
    height: 69.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.27375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 418.625
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 453.18,
    width: 58.19,
    height: 81.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.476153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 493.985
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 534.8,
    width: 58.19,
    height: 81.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 575.6949999999999
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.78,
    y: 616.58,
    width: 58.19,
    height: 83.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.875,
    y: 658.2900000000001
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 40.16,
    width: 64.21,
    height: 83.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.701666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.07499999999999,
    y: 82.15
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.18,
    y: 40.16,
    width: 75.65,
    height: 83.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.405555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.005,
    y: 82.15
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.82,
    y: 40.16,
    width: 89.32,
    height: 83.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.998333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.48,
    y: 82.15
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.14,
    y: 40.16,
    width: 90.14,
    height: 83.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.634545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.21,
    y: 82.15
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.28,
    y: 40.16,
    width: 93.04,
    height: 83.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.79999999999995,
    y: 82.15
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.33,
    y: 40.16,
    width: 101.66,
    height: 83.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.331111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.16,
    y: 82.15
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.98,
    y: 40.16,
    width: 116.02,
    height: 83.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.996666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 641.99,
    y: 82.15
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 124.14,
    width: 110.54,
    height: 93.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.671428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.24000000000001,
    y: 170.84
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 217.55,
    width: 110.54,
    height: 95.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.24000000000001,
    y: 265.52
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 313.49,
    width: 110.54,
    height: 102.27,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.227
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.24000000000001,
    y: 364.625
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 415.76,
    width: 110.54,
    height: 110.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.046363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.24000000000001,
    y: 471.015
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.97,
    y: 526.27,
    width: 110.54,
    height: 173.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.282222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.24000000000001,
    y: 613.135
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 124.14,
    width: 240.33,
    height: 167.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.924285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.675,
    y: 207.875
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.84,
    y: 124.14,
    width: 279.16,
    height: 167.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.882307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.42,
    y: 207.875
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.51,
    y: 291.61,
    width: 519.49,
    height: 408.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.126363636363635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.255,
    y: 495.805
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1940);
export default __webpack_public_path__ + "static/media/1940.9937390e9497a5b2c595cfe4b950e486.svg";
export { ForwardRef as ReactComponent };